module.exports = __webpack_public_path__ + "static/media/delete-icon.25c0c226.gif";